var option_default = {
  "option": "DhjBV",
  "user_choice": "iLUke",
  "check": "NLZWS",
  "image": "QM9ut",
  "input": "_1rmkd",
  "title": "i5LQt",
  "centered": "eBxId",
  "with_result": "Zzf9h",
  "list": "i4v-N",
  "with_image": "FsHwV",
  "progress": "_6YsID",
  "progress_value": "vCTuJ",
  "label": "_4BFSy",
  "cta": "eUHVu",
  "adornment_icon": "VciT4",
  "remove": "FjdJY",
  "removeButton": "pBq4p",
  "removeButtonIcon": "sMJ7F",
  "overlay": "ip5Y-",
  "shown": "_-5nZ3",
  "dark": "ZGQ-v",
  "spinner": "J1ExZ",
  "spin": "zvUkk"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
